import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./ValidationError.scss";

const ValidationError = ({ error, className }) => {
  return (
    error && (
      <span className={classNames("validation-error", className)}>
        {error.join(", ")}
      </span>
    )
  );
};

ValidationError.propTypes = {
  className: PropTypes.string,
  error: PropTypes.arrayOf(PropTypes.string),
};

export default ValidationError;
